import { render, staticRenderFns } from "./ChangeHistoryShow.vue?vue&type=template&id=350da2f0&"
import script from "./ChangeHistoryShow.vue?vue&type=script&lang=js&"
export * from "./ChangeHistoryShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports